export type FacilityWorkflowStagePayload = {
	readonly stage: number;
	readonly documentTypes: readonly { readonly id: number }[];
};

export type FacilityWorkflowAutomaticSourcePayload = {
	readonly documentType: { readonly id: number };
	readonly verifiedOnly: boolean;
};

/** One group of documents proposed in the facility, as `GET /facilities/{facility}/workflows` renders it. */
export type FacilityWorkflowPayload = {
	readonly key: string;
	readonly label: string;
	readonly description: string | null;
	readonly requiresValidationBeforeNext: boolean;
	readonly stages: readonly FacilityWorkflowStagePayload[];
	readonly automaticSources: readonly FacilityWorkflowAutomaticSourcePayload[];
};

export type FacilityWorkflowsFetchedAction = {
	type: 'FACILITY_WORKFLOWS_FETCHED';
	payload: FacilityWorkflowPayload[];
	facilityId: number;
	subjectTypeKey: string;
};

export default (
	payload: FacilityWorkflowPayload[],
	facilityId: number,
	subjectTypeKey: string,
): FacilityWorkflowsFetchedAction => ({
	type: 'FACILITY_WORKFLOWS_FETCHED',
	payload,
	facilityId,
	subjectTypeKey,
});
